import { Component, Input } from '@angular/core'
import { productFilterOption } from '../../../../shared/mb-constants'
import { FilterProductsService } from '../../../services/filter-products.service'
import { ProductVariantFilterData, ProductVariantFilterOptionData } from '../../../../models'
import { take } from 'rxjs/operators'

@Component({
  selector: 'mb-pdp-product-filter',
  templateUrl: './pdp-product-filter.component.html',
  styleUrls: ['./pdp-product-filter.component.scss']
})
export class PdpProductFilterComponent {

  isAntibody$ = this.filterProductsService.isAntibody$
  #filterData: ProductVariantFilterData | undefined

  get filterData () {
    return this.#filterData
  }

  @Input()
  set filterData (filterData) {
    if (filterData) {
      this.#filterData = filterData
      if(!filterData.filterOptions.find(fo => fo.active)) {
        // nothing set, try to select first value (business requirement)
        this.filterProductsService.isDirty$.pipe(
          take(1)
        ).subscribe(isDirty => !isDirty && this.applyFilter(filterData.filterOptions[0]))
      }
    }
  }

  get name () {
    return this.filterData?.name?.toLowerCase()
  }

  get code () {
    return this.filterData?.code
  }

  get values () {
    return this.filterData?.filterOptions
  }

  get isPrimaryFilter () {
    return this.filterData?.isPrimaryFilter || false
  }

  get prov () {
    return this.filterData?.prov || false
  }

  get urlName () {
    return this.filterData?.urlName
  }

  get selectedFilterValue () {
    return this.values?.filter(v => v.active).map(v => v.name)
  }

  productFilterOption = productFilterOption

  constructor (protected filterProductsService: FilterProductsService) {
  }

  async applyFilter (filterOption: ProductVariantFilterOptionData) {
    await this.filterProductsService.applyFilter({
      filterCode: this.code,
      valueCode: filterOption?.code,
      isPrimaryFilter: this.isPrimaryFilter,
      active: true // always true since you cannot unselect a facet only change it to a different one
    })
  }
}
